<template>
  <div>
    <template v-if="!disabled">
      <router-link :to="{name: name}">
        <div class="nav-button" v-bind:class="{'selected': $route.name === name}">
          {{name}}
        </div>
      </router-link>
      <div
        v-bind:class="{'fancy-bar': $route.name === name}"
        v-bind:style="{'background-color': color}"
      ></div>
    </template>
    <template v-else>
      <div class="nav-button disabled">{{name}}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "NavButton",
  props: {
    name: String,
    color: String,
    disabled: Boolean
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-button {
  height: 100%;
  text-align: center;
  padding-top: 10px;
}
a {
  text-decoration: none;
  color: white;
  text-transform: capitalize;
}
a:hover {
  text-decoration: none;
  color: white;
}
.selected {
  font-weight: bold;
}
.disabled {
  user-select: none;
  color: #888888;
  text-transform: capitalize;
}
@-webkit-keyframes stretch {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.fancy-bar {
  position: relative;
  height: 10%;
  bottom: 10%;
  animation-name: stretch;
  animation-duration: 0.2s;
  animation-iteration-count: 1;
}
.notification {
  position: relative;
  top: -10px;
  right: 0px;
  font-size: 12px;
  color: #ff7e00;
}
</style>
